window.addEventListener('alpine:init', () => {
  function facetsForm(data = {}) {
    var { removeSectionWrapper } = Alpine.store('utilities');

    return {
      ...data,

      isLoadingFacetsForm: false,

      rootEl: this.$root,

      onSubmit() {
        if (this.isLoadingFacetsForm) return;

        this.isLoadingFacetsForm = true;

        dispatchEvent(new CustomEvent('facetsformsubmitstart'));

        var url = new URL(location);

        url.search = `?${new URLSearchParams(new FormData(this.rootEl)).toString()}`;

        this.submit(url);
      },

      submit(url) {
        var sectionUrl = new URL(url);

        sectionUrl.searchParams.set('section_id', this.sectionId);

        fetch(sectionUrl)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            dispatchEvent(new CustomEvent('facetsformsubmitsuccess', { detail: { url, sectionHtml } }));
          })
          .catch((err) => () => {
            dispatchEvent(new CustomEvent('facetsformsubmiterror'));
          })
          .finally(() => {
            this.isLoadingFacetsForm = false;
            dispatchEvent(new CustomEvent('facetsformsubmitend'));
          });
      }
    };
  };

  Alpine.data('facetsForm', facetsForm);
});
